import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Input, Modal, Segmented, Select } from 'antd';
import { fetchCompanyWorks } from '../../webviewer/requests/companyWorks';
import { TEMPLATABLE_DEFAULT, TEMPLATABLE_OPTIONS } from '../../webviewer/utils/webTemplateTemplatable';
import { KIND_DEFAULT, KIND_OPTIONS, kindDescription } from '../../webviewer/utils/webTemplateKind';

// Pendant de NewTemplateModal pour les templates de site web : même mise en
// page, réduite aux champs que le back accepte à la création. Comme au
// classique, le métier ne concerne que l'opportunité : le back refuse un
// métier sur un template de site d'offre.
const NewWebTemplateModal = ({ open, creating, onCreate, onCancel }) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [templatable, setTemplatable] = useState(TEMPLATABLE_DEFAULT);
  const [kind, setKind] = useState(KIND_DEFAULT);
  const [work, setWork] = useState(null);
  const [works, setWorks] = useState([]);

  useEffect(() => {
    fetchCompanyWorks()
      .then((companyWorks) => {
        setWorks(companyWorks);
        if (companyWorks.length === 1) setWork(companyWorks[0]);
      })
      .catch(() => setWorks([]));
  }, []);

  const isOffer = templatable === 'offer';
  const canSubmit = name.trim() !== '' && (isOffer || !!work);

  const submit = () => {
    if (!canSubmit) return;
    onCreate({ name: name.trim(), templatable, kind, work: isOffer ? null : work });
  };

  return (
    <Modal
      title={`${t('new-name')} site web`}
      open={open}
      onCancel={onCancel}
      width={560}
      footer={[
        <Button key='back' onClick={onCancel}>
          {t('cancel')}
        </Button>,
        <Button key='submit' type='primary' disabled={!canSubmit} loading={creating} onClick={submit}>
          {t('create')}
        </Button>,
      ]}
    >
      <Form layout='vertical' requiredMark={false}>
        <Form.Item label={t('name')} required>
          <Input
            autoFocus
            placeholder='Ex : Template Commercial 2025'
            value={name}
            onChange={(e) => setName(e.target.value)}
            onPressEnter={submit}
          />
        </Form.Item>

        <Form.Item label='Usage' extra={kindDescription(kind)}>
          <Segmented block value={kind} onChange={setKind} options={KIND_OPTIONS} />
        </Form.Item>

        <Form.Item label='Rattachement'>
          <Segmented block value={templatable} onChange={setTemplatable} options={TEMPLATABLE_OPTIONS} />
        </Form.Item>

        {!isOffer && (
          <Form.Item label='Choix du métier' style={{ marginBottom: 0 }}>
            <Select
              value={work}
              onChange={setWork}
              placeholder='Sélectionner un métier'
              notFoundContent='Aucun métier disponible'
              style={{ width: '100%' }}
              options={works.map((item) => ({ value: item, label: t(item) }))}
            />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default NewWebTemplateModal;
